module.exports = require('./default_tracer');



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/